<template>
  <div>
    <basic-container>
      <el-form :model="goodsForm" label-width="110px" class="goods-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="产品名称">
              <el-input v-model="goodsForm.name" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品价格">
              <el-input v-model="goodsForm.price" placeholder="请输入产品价格" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采购价">
              <el-input v-model.number="goodsForm.purchasePrice" type="number" step="0.01" placeholder="请输入采购价" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平方用量">
              <el-input v-model.number="goodsForm.areaUsage" type="number" step="0.01" placeholder="请输入平方用量" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否参与计算">
              <el-select v-model="goodsForm.splitFlag" placeholder="请选择是否参与计算" clearable style="width: 100%;">
                <el-option :key="0" label="否" :value="0"></el-option>
                <el-option :key="1" label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分组">
              <el-input v-model.number="goodsForm.costGrouping" type="number" placeholder="请输入分组" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="材料类型">
              <el-select v-model="goodsForm.materialType" placeholder="请选择材料类型" clearable style="width: 100%;">
                <el-option :key="0" label="其它" :value="0"></el-option>
                <el-option :key="1" label="刚性" :value="1"></el-option>
                <el-option :key="2" label="柔性" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最低平方用料（元/平方）">
              <el-input v-model.number="goodsForm.areaCost" type="number" step="0.01" placeholder="请输入最低平方用料" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平方用料上限（元/平方）">
              <el-input v-model.number="goodsForm.areaCostCap" type="number" step="0.01" placeholder="请输入平方用料上限" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="form-actions">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
        <el-button type="primary" size="small" @click="submit" icon="el-icon-circle-check-outline">确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { updateGoods, getGoodsForm } from "@/api/work/waterProof/purWaterGoods";
import { DIC } from "@/const/dic";

export default {
  data() {
    return {
      units: [
        { value: 'DAY', valueName: '天' },
        { value: 'MOON', valueName: '月' },
        { value: 'YEAR', valueName: '年' },
      ],
      goodsForm: {
        name: '',
        id: '',
        purchasePrice: '',
        areaUsage: '',
        materialType: '',
        areaCost: '',
        areaCostCap: '',
        filters: []
      },
      goodsFormData: [],
      formData: '',
      isPas: false,
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      dynamicForm: {
        formName: '',
        formType: ''
      },
      dynamicTypes: [],
      dynamicFormData: []
    };
  },
  created() {
    const goodsId = this.$route.query.GoodsId;
    if (goodsId) {
      this.fetchGoodsData(goodsId);
    }
  },
  methods: {
    fetchGoodsData(goodsId) {
      getGoodsForm(goodsId).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.goodsForm = data;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    goBack() {
      let item = {
        close: true,
        label: "编辑净水产品",
        value: "/work/waterProject/purWaterGoods/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    submit() {
      const submitData = {
        ...this.goodsForm
      };
      updateGoods(submitData).then(res => {
        if (res.code === "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.$store.commit('DEL_ALL_TAG');
          this.$router.go(-1);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleSteppingDelete(index) {
      if (this.goodsFormData.length === 1) {
        this.$message({
          showClose: true,
          message: "动态产品不能为空",
          type: "error"
        });
      } else {
        this.goodsFormData.splice(index, 1);
      }
    },
    handleAddRows() {
      this.goodsFormData.push({
        name: '',
        time: '',
        unit: '',
      });
    }
  }
};
</script>

<style scoped>
.goods-form .el-form-item {
  display: flex;
}
.goods-form .el-form-item .el-form-item__content {
  flex: 1;
}
.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 12px;
}
</style>
